import DownChevron from '@img/icons/chevron-down.svg';
import UpChevron from '@img/icons/chevron-up.svg';
import React, { useCallback, useEffect, useMemo, useState, Fragment, } from 'react';
import S from './DesktopDropdown.styles';
import { getDropdownItems } from '../helpers';
const DesktopDropdown = ({ isActive, items }) => {
    const [activeLevel1, setActiveLevel1] = useState(null);
    const [activeLevel2, setActiveLevel2] = useState(null);
    // Reset state if navigation is toggled.
    useEffect(() => {
        if (isActive) {
            setActiveLevel1(null);
            setActiveLevel2(null);
        }
    }, [isActive]);
    const tabIndex = useMemo(() => (isActive ? 0 : -1), [isActive]);
    const onItemClick = useCallback((event, item) => {
        const dropdownItems = getDropdownItems(item);
        if (dropdownItems?.length > 0) {
            event.preventDefault();
            setActiveLevel2(null);
            if (item.id !== activeLevel1?.id) {
                const levelToSet = item?.children?.length ? item : null;
                setActiveLevel1(levelToSet);
            }
            else {
                setActiveLevel1(null);
            }
        }
    }, [setActiveLevel1, setActiveLevel2, activeLevel1]);
    const onItemKeyDown = useCallback((event) => {
        switch (event.key) {
            case 'ArrowRight':
                setActiveLevel1(activeLevel2);
                break;
            case 'ArrowLeft':
                setActiveLevel1(null);
                break;
            default:
                break;
        }
    }, [activeLevel2, setActiveLevel1]);
    const renderItem = useCallback((item) => {
        const dropdownItems = getDropdownItems(item);
        const isActive = item.id === activeLevel1?.id;
        const icon = isActive ? React.createElement(UpChevron, null) : React.createElement(DownChevron, null);
        return (React.createElement(S.Item, null,
            React.createElement(S.Link, { href: item.url, target: item.target },
                React.createElement(S.Text, null, item.text)),
            dropdownItems?.length > 0 && (React.createElement(S.ChevronLink, { href: '#', "data-active": isActive, onKeyDown: onItemKeyDown, onClick: (event) => onItemClick(event, item) }, icon))));
    }, [activeLevel1, onItemClick, onItemKeyDown, tabIndex]);
    const onLevel1Click = useCallback((event, item) => {
        const dropdownItems = getDropdownItems(item);
        if (dropdownItems?.length > 0) {
            event.preventDefault();
            if (item.id !== activeLevel2?.id) {
                const levelToSet = item?.children?.length ? item : null;
                setActiveLevel2(levelToSet);
            }
            else {
                setActiveLevel2(null);
            }
        }
    }, [setActiveLevel2, activeLevel2]);
    const onLevel1KeyDown = useCallback((event, item) => {
        switch (event.key) {
            case 'ArrowRight':
                setActiveLevel2(item);
                break;
            case 'ArrowLeft':
                setActiveLevel2(null);
                break;
            default:
                break;
        }
    }, [setActiveLevel2]);
    const renderLevel1Item = useCallback((item) => {
        const dropdownItems = getDropdownItems(item);
        const isActive = item.id === activeLevel2?.id;
        const icon = isActive ? React.createElement(UpChevron, null) : React.createElement(DownChevron, null);
        return (React.createElement(S.Item, null,
            React.createElement(S.Link, { href: item.url, tabIndex: tabIndex, target: item.target },
                React.createElement(S.Text, null, item.text)),
            dropdownItems?.length > 0 && (React.createElement(S.ChevronLink, { href: '#', "data-active": isActive, onClick: (event) => onLevel1Click(event, item), onKeyDown: (event) => onLevel1KeyDown(event, item) }, icon))));
    }, [activeLevel2, onLevel1Click, onLevel1KeyDown, tabIndex]);
    const renderLevel2Items = useCallback((item) => {
        if (activeLevel2?.id !== item.id || !activeLevel2?.children?.length) {
            return null;
        }
        return (React.createElement(React.Fragment, null, getDropdownItems(activeLevel2).map((level2Item) => (React.createElement(S.Item, { key: level2Item.id },
            React.createElement(S.Link, { href: level2Item.url, tabIndex: tabIndex, target: level2Item.target },
                React.createElement(S.Text, null, level2Item.text)))))));
    }, [activeLevel2, tabIndex]);
    return (React.createElement(S.Container, null,
        React.createElement(S.List, null, items.map((item) => (React.createElement(Fragment, { key: item.id },
            renderItem(item),
            React.createElement(S.Item, null,
                React.createElement(S.SubList, { "data-active": activeLevel1?.id === item.id }, activeLevel1?.id === item.id && !!activeLevel1?.children?.length && (React.createElement(React.Fragment, null, getDropdownItems(activeLevel1).map((level1Item) => (React.createElement(Fragment, { key: level1Item.id },
                    renderLevel1Item(level1Item),
                    React.createElement(S.Item, null,
                        React.createElement(S.SubList, { "data-active": activeLevel2?.id === level1Item.id }, renderLevel2Items(level1Item))))))))))))))));
};
export default DesktopDropdown;
